/* ===== APP ===== */
export const LOADER = "LOADER";
export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
/* ===== END APP ===== */

/* ===== AUTH ===== */
export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const SUCCESS_LOGIN = "SUCCESS_LOGIN";
export const FAIL_LOGIN = "FAIL_LOGIN";

export const REQUEST_LOGOUT = "REQUEST_LOGOUT";
export const SUCCESS_LOGOUT = "SUCCESS_LOGOUT";
export const FAIL_LOGOUT = "FAIL_LOGOUT";

export const REQUEST_FORGOT_PASSWORD = "REQUEST_FORGOT_PASSWORD";
export const SUCCESS_FORGOT_PASSWORD = "SUCCESS_FORGOT_PASSWORD";
export const FAIL_FORGOT_PASSWORD = "FAIL_FORGOT_PASSWORD";
export const CLEAR_FORGOT_PASSWORD = "CLEAR_FORGOT_PASSWORD";

export const REQUEST_RESET_PASSWORD = "REQUEST_RESET_PASSWORD";
export const SUCCESS_RESET_PASSWORD = "SUCCESS_RESET_PASSWORD";
export const FAIL_RESET_PASSWORD = "FAIL_RESET_PASSWORD";
export const CLEAR_RESET_PASSWORD = "CLEAR_RESET_PASSWORD";
/* ===== END AUTH ===== */

/* ===== SURVEYS ===== */
export const LOAD_SURVEYS = "LOAD_SURVEYS";
export const SUCCESS_LOAD_SURVEYS = "SUCCESS_LOAD_SURVEYS";
export const FAIL_LOAD_SURVEYS = "FAIL_LOAD_SURVEYS";
/* ===== END SURVEYS ===== */

/* ===== CREATE SURVEY ===== */
export const CREATE_SURVEY = "CREATE_SURVEY";
export const SUCCESS_CREATE_SURVEY = "SUCCESS_CREATE_SURVEY";
export const FAIL_CREATE_SURVEY = "FAIL_CREATE_SURVEY";
/* ===== END CREATE SURVEY ===== */

export const SUCCESS_UPDATE_SURVEY_TITLE = 'SUCCESS_UPDATE_SURVEY_TITLE';

/* ===== LOAD SINGLE SURVEY ===== */
export const LOAD_SURVEY = "LOAD_SURVEY";
export const SUCCESS_LOAD_SURVEY = "SUCCESS_LOAD_SURVEY";
export const FAIL_LOAD_SURVEY = "FAIL_LOAD_SURVEY";
/* ===== END LOAD SINGLE SURVEY ===== */

/* ===== CHANGE SURVEY STATUS ===== */
export const SUCCESS_CHANGE_SURVEY_STATUS = "SUCCESS_CHANGE_SURVEY_STATUS";
/* ===== END CHANGE SURVEY STATUS ===== */

/* ===== ADD ADD SURVEY LANGUAGE ===== */
export const SUCCESS_ADD_SURVEY_LANGUAGE = "SUCCESS_ADD_SURVEY_LANGUAGE";
/* ===== END ADD ADD SURVEY LANGUAGE ===== */

/* ===== ADD QUESTION ===== */
export const ADD_SURVEY_QUESTION = "ADD_SURVEY_QUESTION";
export const SUCCESS_ADD_SURVEY_QUESTION = "SUCCESS_ADD_SURVEY_QUESTION";
export const FAIL_ADD_SURVEY_QUESTION = "FAIL_ADD_SURVEY_QUESTION";
/* ===== END ADD QUESTION ===== */

/* ===== UPDATE QUESTION ORDER ===== */
export const UPDATE_SURVEY_ITEMS_ORDER = "UPDATE_SURVEY_ITEMS_ORDER";
export const UPDATE_SURVEY_ITEMS_ORDER_SUCCESSFUL =
  "UPDATE_SURVEY_ITEMS_ORDER_SUCCESSFUL";


/* ===== UPDATE QUESTION ===== */
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const SUCCESS_UPDATE_QUESTION = "SUCCESS_UPDATE_QUESTION";
export const FAIL_UPDATE_QUESTION = "FAIL_UPDATE_QUESTION";
/* ===== END UPDATE QUESTION ===== */

/* ===== DELETE QUESTION ===== */
export const SUCCESS_DELETE_QUESTION = "SUCCESS_DELETE_QUESTION";
/* ===== END DELETE QUESTION ===== */

/* ===== LOAD QUESTION SETS ===== */
export const LOAD_QUESTIONSETS = "LOAD_QUESTIONSETS";
export const SUCCESS_LOAD_QUESTIONSETS = "SUCCESS_LOAD_QUESTIONSETS";
export const FAIL_LOAD_QUESTIONSETS = "FAIL_LOAD_QUESTIONSETS";
/* ===== END LOAD QUESTION SETS ===== */

/* ===== CREATE QUESTION SET ===== */
export const CREATE_QUESTIONSET = "CREATE_QUESTIONSET";
export const SUCCESS_CREATE_QUESTIONSET = "SUCCESS_CREATE_QUESTIONSET";
export const FAIL_CREATE_QUESTIONSET = "FAIL_CREATE_QUESTIONSET";
/* ===== END CREATE QUESTION SET ===== */

export const SUCCESS_CHANGE_QUESTIONSET_TITLE = "SUCCESS_CHANGE_QUESTIONSET_TITLE";

/* ===== LOAD QUESTION SET BY ID ===== */
export const LOAD_QUESTIONSET = "LOAD_QUESTIONSET";
export const SUCCESS_LOAD_QUESTIONSET = "SUCCESS_LOAD_QUESTIONSET";
export const FAIL_LOAD_QUESTIONSET = "FAIL_LOAD_QUESTIONSET";
/* ===== END LOAD QUESTION SET BY ID ===== */

/* ===== ADD QUESTION ===== */
export const ADD_QUESTIONSET_QUESTION = "ADD_QUESTIONSET_QUESTION";
export const SUCCESS_ADD_QUESTIONSET_QUESTION =
  "SUCCESS_ADD_QUESTIONSET_QUESTION";
export const FAIL_ADD_QUESTIONSET_QUESTION = "FAIL_ADD_QUESTIONSET_QUESTION";
/* ===== END ADD QUESTION ===== */

/* ===== DELETE QUESTION ===== */
export const SUCCESS_DELETE_QUESTIONSET_QUESTION =
  "SUCCESS_DELETE_QUESTIONSET_QUESTION";
/* ===== END DELETE QUESTION ===== */

/* ===== ADD QUESTION SET LANGUAGE ===== */
export const SUCCESS_ADD_QUESTIONSET_LANGUAGE =
  "SUCCESS_ADD_QUESTIONSET_LANGUAGE";
/* ===== END ADD QUESTION SET LANGUAGE ===== */

/* ===== CHANGE QUESTIONSET STATUS ===== */
export const SUCCESS_CHANGE_QUESTIONSET_STATUS =
  "SUCCESS_CHANGE_QUESTIONSET_STATUS";
/* ===== END CHANGE QUESTIONSET STATUS ===== */

export const SUBMIT_FORM = "SUBMIT_FORM";
export const SUCCESS_SUBMIT_FORM = "SUCCESS_SUBMIT_FORM";
export const FAIL_SUBMIT_FORM = "FAIL_SUBMIT_FORM";
